class MediaSlider {
  init() {
    this.sliderInit();
  }

  /**
   * Create swiper slider.
   *
   * A slider full of youtube embeds that are created once the slide is active
   *
   * @memberof MediaSlider
   */
  sliderInit() {
    Array.from(document.querySelectorAll('.js-media-slider')).forEach(
      slider => {
        const _this = this;

        // eslint-disable-next-line no-unused-vars
        const mySwiper = new Swiper(slider, {
          speed: 400,
          slidesPerView: 3,
          centeredSlides: true,
          keyboard: {
            enabled: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            // when window width is <= 481
            480: {
              slidesPerView: 1
            },

            // when window width is <= 781px
            780: {
              slidesPerView: 2,
              centeredSlides: false
            }
          },
          on: {
            init() {
              _this.createEmbed(this);
            },

            slideChangeTransitionStart() {
              // console.log('slideChangeTransitionStart', e);
              // console.log(' this.activeIndex();', this.activeIndex);
              _this.createEmbed(this);
            }
          }
        });
      }
    );
  }

  createEmbed(slider) {
    const activeSlide = slider.slides[slider.activeIndex];
    const slideIFrame = activeSlide.querySelector('iframe');
    const embedWrapper = activeSlide.querySelector('.o-embed-wrapper');

    function iframeLoaded() {
      activeSlide.classList.add('iframe-loaded');
    }

    if (!slideIFrame) {
      const youtubeID = embedWrapper.getAttribute('video-id');

      const iframe = document.createElement('iframe');
      iframe.onload = function() {
        iframeLoaded();
      };
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'src',
        `https://www.youtube.com/embed/${youtubeID}?rel=0&modestbranding=1`
      );

      // embedWrapper.innerHTML = '';
      embedWrapper.appendChild(iframe);
    }
  }
}

export default MediaSlider;
